/** Human-readable titles for stored rule type strings (API contract unchanged). */
export const WORKING_RULE_TYPE_LABELS: Record<string, string> = {
  WEEKDAY_HOURS: 'Weekday hours',
  ANNUAL_OFF: 'Annual time off',
  DATE_OFF: 'One-off day off',
  DATE_HOURS: 'One-off hours'
};

export function workingRuleTypeLabel(ruleType: string): string {
  return WORKING_RULE_TYPE_LABELS[ruleType] ?? ruleType;
}
